module.exports = __webpack_public_path__ + "img/bar-chart-02.40a9f775.svg";